export default __webpack_public_path__ + "static/media/icn_access_control.763f205a.svg";